namespace Nobox.Nobox {
    export interface CampaignresultForm {
        CampaignId: Serenity.ServiceLookupEditor;
        ContactId: Serenity.ServiceLookupEditor;
        ContactLinkId: Serenity.ServiceLookupEditor;
        Group: Serenity.ServiceLookupEditor;
        Status: CampaignResultStatus;
        Tags: Serenity.ServiceLookupEditor;
        ProcessBy: Serenity.ServiceLookupEditor;
        BodyType: Serenity.EnumEditor;
        ProcessDate: CustomDateTimeEditor;
        Subject: Serenity.StringEditor;
        BodyText: Serenity.TextAreaEditor;
        BodyHtml: Serenity.HtmlContentEditor;
        Body: Serenity.StringEditor;
        Button: Serenity.StringEditor;
        ButtonClose: Serenity.Extensions.StaticTextBlock;
        Button1: Serenity.StringEditor;
        Button1Close: Serenity.Extensions.StaticTextBlock;
        Button1CloseHide: Serenity.Extensions.StaticTextBlock;
        Button2: Serenity.StringEditor;
        Button2Close: Serenity.Extensions.StaticTextBlock;
        ButtonCreate: Serenity.Extensions.StaticTextBlock;
        ButtonActType: TypeActionButton;
        ButtonActText: Serenity.StringEditor;
        ButtonAct: Serenity.StringEditor;
        ButtonActClose: Serenity.Extensions.StaticTextBlock;
        ButtonAct1Type: TypeActionButton;
        ButtonAct1Text: Serenity.StringEditor;
        ButtonAct1: Serenity.StringEditor;
        ButtonAct1Close: Serenity.Extensions.StaticTextBlock;
        ButtonActCreate: Serenity.Extensions.StaticTextBlock;
        ListMessage: Serenity.Extensions.StaticTextBlock;
        Attachment: Serenity.MultipleImageUploadEditor;
        Created: CustomDateTimeEditor;
        Sent: CustomDateTimeEditor;
        IsRead: Serenity.BooleanEditor;
        ReadDate: CustomDateTimeEditor;
        Note: Serenity.TextAreaEditor;
        InteractiveMsg: Serenity.StringEditor;
    }

    export class CampaignresultForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Campaignresult';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CampaignresultForm.init)  {
                CampaignresultForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = CampaignResultStatus;
                var w2 = s.EnumEditor;
                var w3 = CustomDateTimeEditor;
                var w4 = s.StringEditor;
                var w5 = s.TextAreaEditor;
                var w6 = s.HtmlContentEditor;
                var w7 = s.Extensions.StaticTextBlock;
                var w8 = TypeActionButton;
                var w9 = s.MultipleImageUploadEditor;
                var w10 = s.BooleanEditor;

                Q.initFormType(CampaignresultForm, [
                    'CampaignId', w0,
                    'ContactId', w0,
                    'ContactLinkId', w0,
                    'Group', w0,
                    'Status', w1,
                    'Tags', w0,
                    'ProcessBy', w0,
                    'BodyType', w2,
                    'ProcessDate', w3,
                    'Subject', w4,
                    'BodyText', w5,
                    'BodyHtml', w6,
                    'Body', w4,
                    'Button', w4,
                    'ButtonClose', w7,
                    'Button1', w4,
                    'Button1Close', w7,
                    'Button1CloseHide', w7,
                    'Button2', w4,
                    'Button2Close', w7,
                    'ButtonCreate', w7,
                    'ButtonActType', w8,
                    'ButtonActText', w4,
                    'ButtonAct', w4,
                    'ButtonActClose', w7,
                    'ButtonAct1Type', w8,
                    'ButtonAct1Text', w4,
                    'ButtonAct1', w4,
                    'ButtonAct1Close', w7,
                    'ButtonActCreate', w7,
                    'ListMessage', w7,
                    'Attachment', w9,
                    'Created', w3,
                    'Sent', w3,
                    'IsRead', w10,
                    'ReadDate', w3,
                    'Note', w5,
                    'InteractiveMsg', w4
                ]);
            }
        }
    }
}
